module.exports = __webpack_public_path__ + "assets/icon-uncategorized.99347044.svg";